/* Basic wrapper around our API, handles autorization
 *
 */

/*
function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
}
*/

class API {
	constructor(baseUrl) {
		this.baseUrl = baseUrl;
		this.headers = {
			"Content-Type": "application/json",
		};
		this.token = "";
		this.user = null;
		this.loggedin = false;
		this.loginCallback = null;
		this.logoutCallback = null;

    //const csrftoken = getCookie('csrftoken');
    //if (csrftoken) this.headers.X_CSRFTOKEN = csrftoken;
	}

	// wrap fetch to raise when http status is not ok
	fetch(url, options) {
		return fetch(url, {
			headers: this.headers,
			...options,
      credentials: 'same-origin',
		})
			.then((r) => {
				if (!r.ok) {
					return r.text().then((body) => {
						const error = new Error(`${r.status} ${r.statusText}`);
						error.status = r.status;
						error.statusText = r.statusText;
						error.body = body;
						throw error;
					});
				}
				return r;
			})
			.then((r) => r.text())
			.then((text) => {
				if (text) return JSON.parse(text);
				return null;
			});
	}

	// wrap http methods
	get(path) {
		return this.fetch(this.baseUrl + path, {
			method: "GET",
		});
	}

	post(path, data) {
		return this.fetch(this.baseUrl + path, {
			method: "POST",
			body: JSON.stringify(data),
		});
	}

	put(path, data) {
		return this.fetch(this.baseUrl + path, {
			method: "PUT",
			body: JSON.stringify(data),
		});
	}

	patch(path, data) {
		return this.fetch(this.baseUrl + path, {
			method: "PATCH",
			body: JSON.stringify(data),
		});
	}

	delete(path) {
		return this.fetch(this.baseUrl + path, {
			method: "DELETE",
		});
	}

	// authorization

	setToken(token) {
		this.token = token;
		localStorage.setItem("token", token);
		this.headers.Authorization = `Token ${token}`;
	}

	removeToken() {
		this.token = null;
		localStorage.removeItem("token");
		this.headers.Authorization = null;
	}

	login(username, password) {
		return this.post("auth/login", { username, password }).then((data) => {
			this.setToken(data.token);
			this.user = data.user;
			this.loggedin = true;
			if (this.loginCallback) this.loginCallback();
			return data;
		});
	}

	logout(username, password) {
		return this.post("auth/logout").then((data) => {
			this.removeToken();
			this.user = null;
			this.loggedin = false;
			if (this.logoutCallback) this.logoutCallback();
		});
	}

	init() {
		if (localStorage.getItem("token")) {
			this.setToken(localStorage.getItem("token"));
			return this.get("auth/loggedin").then((data) => {
				if (data.loggedin) {
					this.loggedin = true;
					return this.get("auth/user").then((data) => {
						this.user = data;
						return Promise.resolve(true);
					});
				} else {
					this.removeToken();
					return Promise.resolve(false);
				}
			}).catch(() => {
        this.removeToken();
        this.loggedin = false;
      });
		}

		return Promise.resolve(false);
	}
}

const api = new API(API_BASE_URL);
export default api;
